<template>
  <div id="app" :class="[{'mobile' : isMobile}, activePanel, _.toLower($route.name)]">
    <slot v-if="ready">
      <Header></Header>
      <div class="inc">
        <router-view/>
      </div>
      <Footer></Footer>
    </slot>
  </div>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  export default{
    metaInfo () {
      return {
        title: (!_.isUndefined(this.$pageMeta()) ? this.$pageMeta() : '') + ' Ödeme Veznesi', 
      }
    },
    data(){
      return{
        activePanel: '',
      }
    },
    components:{
      Header,
      Footer,
    },
    computed:{
      auth(){
      },
      ready(){
        return this.$store.getters['getReady'];
      },
      init(){
        return this.$store.getters['getInit'];
      },
    },
    methods:{
    },
    created(){
      this.$store.dispatch('initClient');
      this.$store.dispatch('auth/userFetch')
    },
    watch:{
    },
  }
</script>
